import BaseUtil from "../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isExpired: false, // 医院是否到期
    isExecuting: true,
    error: null,

    isShowLoginInfo: false,
    loginInfo: null,

    installStatus: { // 当前医院的启用信息
        unitCount: null, // 科室数量
        authStatus: null, // 排班鉴权对象 "管理员"  "全部员工"  "部分员工"  null
    },

    dingSynVisible: false,
    dingSynProgress: 0,

    chatGroupQr: null, // 显示加群二维码

    // updateNotice: null, // 最新升级公告
    embed: false, // 隐藏顶部
    showExpireNotify: false,
    expiredDays: null,
    joinData: {},
    SMSCodeStatus: {},
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
